module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag, {
    tag: "component",
    staticClass: "dropdown-header",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-791c838c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/dropdown-header.vue
// module id = 247
// module chunks = 0